import React from "react";
import { AuthUserContext, withAuthorization } from "../../Auth/Session";
import Metabase from "../Metabase";
import { validateMetaLanguage } from "../../../utils/validateMetaLanguage";

class Dismount extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <Metabase dashboardId={validateMetaLanguage(860, 948)} />
        )}
      </AuthUserContext.Consumer>
    );
  };
}

const condition = authUser =>
  !!authUser;

export default withAuthorization(condition)(Dismount);